<div class="alert-message-container" *ngIf="messages && messages.length > 0">
    <div class="alert-message" *ngFor="let message of messages">
        <minster-alert-message #messageComponents [message]="message" (close)="messageClosed($event)"></minster-alert-message>
    </div>
</div>
